module.exports = __webpack_public_path__ + "img/title-back.e13c7bc6.png";